import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Divider,
  Typography,
  Tooltip
} from '@mui/material';
import { RecommendedComponents } from '../components/recommended-components';
import { ArrowLeft as ArrowLeftIcon } from '../icons/arrow-left';

export const DepartmentDetail = () => {
  const location = useLocation();
  console.log(`sate-child: ${JSON.stringify(location.state)}`);
  const { data } = location.state;
  return (
    <>
      <Box sx={{ py: 1 }}>
        <Box
          sx={{ ml: 2 }}
        >
          <Button
            color="primary"
            component={RouterLink}
            startIcon={<ArrowLeftIcon />}
            to={`/dashboard/reports/${data?.deptCode}`}
            variant="text"
          >
            {data?.deptName}
          </Button>
        </Box>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            mb: 2,
            ml: 2
          }}
        >
          <Typography
            color="textPrimary"
            variant="h4"
          >
            {/* {departmentState.data.deptName} */}
            評価と推奨アクション
          </Typography>
          {/* <Box sx={{ flexGrow: 1 }} />
          <ActionsMenu actions={actions} /> */}
        </Box>
        <Divider />
        <Box
          sx={{
            alignItems: 'left',
            flexDirection: 'column',
            display: 'flex',
            m: 2,
            p: 1,
            border: 2,
            borderColor: '#cccccc',
            borderRadius: 1
          }}
        >
          <Typography variant="h5">
            評価のコメント
          </Typography>
          <Typography
            variant="body1"
            sx={{
              ml: 2,
              mt: 2
            }}
          >
            {data?.comment}
          </Typography>
        </Box>
        <Box
          sx={{
            alignItems: 'left',
            flexDirection: 'column',
            display: 'flex',
            m: 2,
            p: 1,
            border: 2,
            borderColor: '#cccccc',
            borderRadius: 1
          }}
          maxHeight="460px"
          overflow="auto"
          flex={1}
          flexDirection="column"
          display="flex"
          // p={2}
        >
          <Tooltip
            arrow
            title="ご参考までに、Google Workspace 利用の価値を、獲得していただくための施策案をご提示しています。"
          >
            <Typography variant="h5">
              推奨アクション
            </Typography>
          </Tooltip>
          <Box>
            <RecommendedComponents
              data={data?.recommends}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};
